/**
 * AI随访API
 */
export default {
  aiFollowUpApi: {
    getHospitalStatistics: '/followUp-api/webapi/ai-follow-up/get-hospital-statistics', // 获取当前医院的随访统计
    getDoctorStatistics: '/followUp-api/webapi/ai-follow-up/get-doctor-statistics',     // 获取当前医院医生的随访统计
    getDoctorPatientInfo: '/followUp-api/webapi/ai-follow-up/get-doctor-patient-info',      // 获取当前医院医生的随访患者列表
    getFollowUp: '/followUp-api/webapi/ai-follow-up/get-follow-up',      // 获取随访详情
    getFollowUpListExcel: '/followUp-api/webapi/ai-follow-up/get-follow-up-list-excel-file',      // 获取当前医院医生的随访患者列表Excel
    getFollowUpDetailExcel: '/followUp-api/webapi/ai-follow-up/get-follow-up-detail-excel-file',      // 获取随访详情Excel
    getCurrentHospitalRobots: '/followUp-api/webapi/ai-follow-up/get-current-hospital-robots',      // 获取当前医院可用的话术场景
    createTask: '/followUp-api/webapi/ai-follow-up/create-task',      // 创建随访任务
    startTask: '/followUp-api/webapi/ai-follow-up/start-task',      // 一键随访、开始任务
    stopTask: '/followUp-api/webapi/ai-follow-up/stop-task',      // 停止随访、停止任务
    reply: '/followUp-api/webapi/ai-follow-up/reply',      // 医生回复内容
    getTaskList: '/followUp-api/webapi/ai-follow-up/get-task-list',      // 获取当前医生的随访任务列表
    getTask: '/followUp-api/webapi/ai-follow-up/get-task',      // 获取当前医生上一次随访任务
    insert: '/followUp-api/webapi/ai-follow-up/insert',      // 创建患者信息
    update: '/followUp-api/webapi/ai-follow-up/update',      // 更新患者信息
    delete: '/followUp-api/webapi/ai-follow-up/delete',      // 删除患者信息
    listPatientInfo: '/followUp-api/webapi/ai-follow-up/list-patient-info',      // 获取当前任务的患者信息
    getPatientInfo: '/followUp-api/webapi/ai-follow-up/get-patient-info',      // 获取当前任务的患者信息
    exportPatientInfo: '/followUp-api/webapi/ai-follow-up/get-patients-info',      // 获取当前录入的患者信息
    downloadTemplate: '/followUp-api/webapi/ai-follow-up/down-load-excel', // 下载模板
    uploadExcel: '/followUp-api/webapi/ai-follow-up/up-load-excel', // 上传excel
    getTemplateList: '/followUp-api/webapi/ai-follow-up/template-detail', // 获取模板内容列表
    getHospitalsStatistics: '/followUp-api/webapi/ai-follow-up/get-hospital-statistics-account', // 获取医院随访统计的数据
    getDoctorsStatistics: '/followUp-api/webapi/ai-follow-up/get-doctor-statistics-count', // 获取各医生随访统计的数据
    getAccountStatistics: '/followUp-api/webapi/ai-follow-up/get-doctor-statistics-account' // 获取账户随访统计的数据

  }
}
